import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/contact/page.tsx");
